import { Link } from "react-router-dom";
import styled from "styled-components";

type Props = { name: string; image: string; href: string };

export default function ReciterCard({ name, image, href }: Props) {
  return (
    <Card to={href}>
      <Thumb>
        <Img src={image} alt={name} />
        <Shade />
        <Label>{name}</Label>
      </Thumb>
    </Card>
  );
}

const Card = styled(Link)`
  position:relative; border-radius:16px; overflow:hidden; background:var(--surface);
  box-shadow:0 6px 16px rgba(0,0,0,.12); transition: transform .18s ease, box-shadow .18s ease;
  &:hover{ transform: translateY(-4px); box-shadow:0 12px 24px rgba(0,0,0,.16); }
`;
const Thumb = styled.div` position:relative; width:100%; aspect-ratio:1/1; `;
const Img = styled.img` position:absolute; inset:0; width:100%; height:100%; object-fit:cover; display:block; `;
const Shade = styled.div` position:absolute; inset:0; background:linear-gradient(to top, rgba(0,0,0,.4), transparent 60%); `;
const Label = styled.div`
  position:absolute; bottom:10px; inset-inline:10px; text-align:center; color:#fff; font-weight:600; font-size:1rem; text-shadow:0 1px 2px rgba(0,0,0,.6); z-index:1;
`;
